import { AppBar, Toolbar, useTheme } from "@mui/material";
import {
	DisabledButton,
	EnhancedButtonPrimeReact,
	EnhancedButtonPrimeReactSeverity,
	PrintButton,
} from "@websential/cosmic-v20";
import { FC, useEffect, useState } from "react";

import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import { IAppState } from "../../../../store/reducers";
import PlaylistAddCheckOutlinedIcon from "@mui/icons-material/PlaylistAddCheckOutlined";
import PrintIcon from "@mui/icons-material/Print";
import { selectedRL1SlipType } from "../RL1SlipSetup";
import { useSelector } from "react-redux";

export interface IRL1SlipSetupToolbar {
	onResetClicked?: () => void;
	onDeleteClicked?: () => void;
	onPrintClicked: () => void;
	isSubmitting?: boolean;
	formMethods: any;
	rl1SummaryData: any;
	pageTitle: string;
	id: any
}

export const RL1SlipSetupToolbar: FC<IRL1SlipSetupToolbar> = ({
	onResetClicked,
	onDeleteClicked,
	onPrintClicked,
	isSubmitting,
	formMethods,
	rl1SummaryData,
	pageTitle,
	id,
}) => {
	const theme = useTheme();
	const subMenuVisibility = useSelector(
		(state: IAppState) => state.drawerAction.subMenuVisibility
	);
	const [subMenuVisibilityState, setSubMenuVisibility] = useState(subMenuVisibility)
	useEffect(() => {
		if (subMenuVisibility) {
			setSubMenuVisibility(subMenuVisibility)
		}
	}, [subMenuVisibility])
	const selectedSlip = formMethods.getValues("selectedSlip");

	return (
		<AppBar
			position="sticky"
			color="default"
			elevation={1}
			sx={{
				backgroundColor: "#F7F7F7",
				paddingBottom: "16px",
				boxShadow: "none",
				zIndex: theme.zIndex.appBar + 1,
				position: "sticky",
				top: subMenuVisibility ? "112px" : "64px",
				// top: "112px",
			}}
		>
			<Toolbar
				sx={{
					paddingTop: { sm: 1.75, md: 1.75, lg: 1.75, xl: 1.75 },
					paddingBottom: { sm: 0, md: 0, lg: 0, xl: 0 },
					paddingLeft: { sm: 0, md: 0, lg: 0, xl: 0 },
					paddingRight: { sm: 0, md: 0, lg: 0, xl: 0 },
					minHeight: { sm: "48px", md: "48px", lg: "48px", xl: "48px" },
					fontWeight: "700",
					display: "flex",
					justifyContent: "space-between",
				}}
			>
				<div style={{ fontSize: "1.5rem", fontWeight: "bold" }}>
					{pageTitle}
				</div>
				<div
					style={{
						display: "flex",
						justifyContent: "center",
						alignItems: "center",
					}}
				>
					<div>
						{rl1SummaryData &&
							rl1SummaryData.confirmationCode !== null &&
							selectedRL1SlipType === 400 ? (
							<div style={{ cursor: "not-allowed" }}>
								<DisabledButton
									tooltiptitle={
										"Confirmation No. has been enterned in [Complaince -> rl1 -> Summary]"
									}
									isDisabled={true}
									buttonLabel={"Submit"}
									icon={<PlaylistAddCheckOutlinedIcon />}
									testId="disableButton"
								/>
							</div>
						) : (
							// <SubmitButton
							// 	label="Submit"
							// 	testId="submit-button"
							// 	loading={isSubmitting}
							// 	icon={<PlaylistAddCheckOutlinedIcon />}
							// />
							<EnhancedButtonPrimeReact
								label="Submit"
								loading={isSubmitting}
								type="submit"
								raised
								severity={EnhancedButtonPrimeReactSeverity.Success}
							/>
						)}
					</div>
					{/* <ResetButton testId="reset-button" onClickHandler={onResetClicked} /> */}
					<EnhancedButtonPrimeReact
						label="Reset"
						raised
						onClickHandler={onResetClicked}
						style={{ marginLeft: "1rem" }}
						severity={EnhancedButtonPrimeReactSeverity.Secondary}
					/>
					<div>
						{rl1SummaryData &&
							rl1SummaryData.confirmationCode !== null &&
							selectedRL1SlipType === 400 ? (
							<div style={{ cursor: "not-allowed", marginLeft: "1rem" }}>
								<DisabledButton
									tooltiptitle={
										"Confirmation No. has been enterned in [Complaince -> t4 -> Summary]"
									}
									isDisabled={true}
									buttonLabel={"Delete"}
									icon={<DeleteOutlineIcon />}
									testId="disableButton"
								/>
							</div>
						) : selectedSlip && selectedSlip === "create-new" ? (
							<div style={{ cursor: "not-allowed", marginLeft: "1rem" }}>
								<DisabledButton
									tooltiptitle={""}
									isDisabled={true}
									buttonLabel={"Delete"}
									icon={<DeleteOutlineIcon />}
									testId="disableButton"
								/>
							</div>
						) : (
							// <DeleteButton
							// 	testId="delete-button"
							// 	onClickHandler={onDeleteClicked}
							// />
							<EnhancedButtonPrimeReact
								label="Delete"
								raised
								onClickHandler={onDeleteClicked}
								style={{ marginLeft: "1rem" }}
								severity={EnhancedButtonPrimeReactSeverity.Danger}
							/>
						)}
					</div>
					<div>
						{selectedSlip && selectedSlip === "create-new" ? (
							<div style={{ cursor: "not-allowed", marginLeft: "1rem" }}>
								<DisabledButton
									tooltiptitle={""}
									isDisabled={!id ? true : false}
									buttonLabel={"Print"}
									icon={<PrintIcon />}
									testId="disableButton"
								/>
							</div>
						) : (
							<EnhancedButtonPrimeReact
								label="Print"
								raised
								onClickHandler={onPrintClicked}
								disabled={!id ? true : false}
								style={{
									marginLeft: "1rem"

								}}
							/>
						)}

					</div>
				</div>
			</Toolbar>
		</AppBar>
	);
};
